import React, { useCallback } from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import useTilt from "../hooks/useTilt";

const iconMap = {
  ai: "fa fa-cogs",
  web3: "fa fa-chain",
  backend: "fa fa-server",
  cloud: "fa fa-cloud",
};

const gradientMap = {
  ai: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
  web3: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
  backend: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
  cloud: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
};

const Card = ({ project, theme, index }) => {
  const [scrollRef, isVisible] = useScrollReveal({ delay: index * 120 });
  const tilt = useTilt(10);
  const mergedRef = useCallback(
    (node) => {
      scrollRef(node);
      tilt.ref.current = node;
    },
    [scrollRef, tilt.ref]
  );

  const icon = project.icon || theme;
  const gradient = gradientMap[icon] || gradientMap.ai;
  const iconClass = iconMap[icon] || iconMap.ai;
  const pills = project.stack.split(",").map((s) => s.trim());

  return (
    <div
      ref={mergedRef}
      className={`project-card ${isVisible ? "reveal-visible" : "reveal"}`}
      onMouseMove={tilt.handleMove}
      onMouseLeave={tilt.handleLeave}
    >
      <div className="card-glare" />
      <div className="card-shine" />
      <div className="project-card-gradient" style={{ background: gradient }}>
        <i className={iconClass} />
      </div>
      <div className="project-card-body">
        <h3 className="project-card-title">{project.title}</h3>
        <p className="project-card-desc">{project.category}</p>
        <div className="project-card-pills">
          {pills.map((pill) => (
            <span key={pill} className="tech-pill">
              {pill}
            </span>
          ))}
        </div>
        <div className="project-card-links">
          <a
            href={project.source}
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa fa-github" /> Source Code
          </a>
        </div>
      </div>
    </div>
  );
};

const ProjectCards = ({ title, data, theme }) => {
  if (!data || data.length === 0) return null;

  return (
    <section id="projects" className="project-cards-section">
      <div className="scan-line" />
      <div className="row">
        <div className="twelve columns collapsed">
          <h1 className="section-heading">
            <span>{title}</span>
          </h1>
          <div className="project-cards-grid">
            {data.map((project, i) => (
              <Card key={project.title} project={project} theme={theme} index={i} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectCards;
